import API from "../global/api";
export const loginRequest = () => {
  window.localStorage.clear();
  return {
    type: "LOGIN_REQUEST",
  };
};
export const loginSuccess = (data) => {
  return {
    type: "LOGIN_SUCCESS",
    payload: data,
  };
};
export const loginError = (msg) => {
  return {
    type: "LOGIN_ERROR",
    payload: msg,
  };
};
export const login = (data, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(loginRequest());
    API.post(`/auth/login`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(loginSuccess(data1));
        window.localStorage.setItem("token", data1.token);
        window.localStorage.setItem("role", data1.role);
        window.localStorage.setItem("isAuthenticated", "true");
        window.location.replace("/main");
      })
      .catch((error) => {
        dispatch(loginError(error.response.data.message));
        handleDangerVisible(error.response.data.message);
      });
  };
};